import React from "react";
import { Link } from "react-router-dom";
import {
	Box,
	Center,
	Container,
	Divider,
	Group,
	Image,
	SimpleGrid,
	Stack,
	Text,
} from "@mantine/core";
import * as yup from "yup";

import { yupHelper } from "utilities/yupHelpers";

import SDAWhiteLogo from "@/assets/sda-outline.svg";
import DataProtectionImage from "assets/data_protection.jpg";
import { ReactComponent as FacebookSVG } from "assets/img/Home/Footer/icon_fb.svg";
import { ReactComponent as InstagramSVG } from "assets/img/Home/Footer/icon_ig.svg";
import { ReactComponent as LinkedInSVG } from "assets/img/Home/Footer/icon_ln.svg";
import { ReactComponent as TikTokSVG } from "assets/img/Home/Footer/icon_tt.svg";
import { ReactComponent as YoutubeSVG } from "assets/img/Home/Footer/icon_yt.svg";

import styles from "./HomeFooter.module.scss";
import IconNoPaddingSVG from "./icon-no-padding.svg";

const schema = yup.object({
	email: yupHelper.email(),
});

const HomeFooter = () => {
	/**
	 * TODO: MISSING
	 *  subscribe to email ?
	 *  contact us form
	 */

	return (
		<>
			<Box
				className={styles.footer_container_with_logo}
				component="footer"
				c="white"
				pos={"relative"}>
				<Container mih={400} py={50}>
					<SimpleGrid
						cols={{
							base: 1,
							md: 3,
						}}
						style={{
							gap: 50,
						}}>
						<Stack>
							<Box>
								<Image h={55} w={"auto"} src={SDAWhiteLogo} />
							</Box>
							<Text size="sm">
								Skills Development Academy Pte Ltd UEN
								<br /> 201734671R
							</Text>
							<Box>
								<Text size="sm">Head Office:</Text>
								<Text size="sm">
									158 Kallang Way, #03-05 Performance Building, Singapore 349245
								</Text>
								<Text size="sm">
									Tel: +65 66537552{" "}
									<Text span c="gray.5" pl={5}>
										(Mon to Sun 9am to 6pm)
									</Text>
								</Text>
							</Box>
						</Stack>
						<Stack>
							<HeaderText>Information</HeaderText>
							<Stack gap={5}>
								{[
									{
										label: "Courses",
										link: "/course",
									},
									{
										label: "Certificate",
										link: "/certification",
									},
									{
										label: "FAQ",
										link: "/faq",
									},
								].map((item) => (
									<Link to={item.link} key={item.link}>
										<Text size="sm" c="white">
											{item.label}
										</Text>
									</Link>
								))}
							</Stack>
						</Stack>
						<Stack gap={"xs"}>
							<HeaderText>Social Media</HeaderText>
							<Group gap={"xs"}>
								{[
									{
										icon: <FacebookSVG style={{ width: 15, height: 15, fill: "white" }} />,
										link: "https://www.facebook.com/sdacademysg",
									},
									{
										icon: <InstagramSVG style={{ width: 15, height: 15, fill: "white" }} />,
										link: "https://www.instagram.com/sdacademysg",
									},
									{
										icon: <LinkedInSVG style={{ width: 15, height: 15, fill: "white" }} />,
										link: "https://www.linkedin.com/company/sdacademysg",
									},
									{
										icon: <YoutubeSVG style={{ width: 15, height: 15, fill: "white" }} />,
										link: "https://www.youtube.com/@sdacademysg",
									},
									{
										icon: <TikTokSVG style={{ width: 15, height: 15, fill: "white" }} />,
										link: "https://www.tiktok.com/@sdacademysg",
									},
								].map((item) => (
									<Link to={item.link} key={item.link} target="_blank">
										<Center bdrs={"100%"} bg="themed-black.8" w={40} h={40}>
											{item.icon}
										</Center>
									</Link>
								))}
							</Group>
							<Box>
								<img
									src={DataProtectionImage}
									style={{ height: 60, width: "auto", objectFit: "contain", cursor: "pointer" }}
								/>
								<Text size="xs" mt="xs">
									Skills Development Academy is certified with the Data Protection Trustmark.
								</Text>
							</Box>
						</Stack>
					</SimpleGrid>
				</Container>
				<Box>
					<Divider color="themed-black.5" />
					<Center py={20}>
						<Text size="xs" c="gray.5">
							{new Date().getFullYear()}©Skills Development Academy . All Rights Reserved.
						</Text>
					</Center>
					{/* <Image
						src={IconNoPaddingSVG}
						pos={"absolute"}
						bottom={0}
						right={0}
						w={400}
						style={{ zIndex: -1 }}
					/> */}
				</Box>
			</Box>
		</>
	);
};

const HeaderText = Text.withProps({
	fw: "bold",
	fz: "sm",
});

export default HomeFooter;
